import styled from 'styled-components'
import { device, colors } from 'Styled/variables'

export const Container = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 0rem;
  @media ${device.mobileMin} {
    row-gap: 0rem;
  }
`

export const ButtonsGroups = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  /* display: flex;
  justify-content: center;
  column-gap: 1rem; */
  @media ${device.mobileMin} {
    display: flex;
    justify-content: center;
    column-gap: 1rem;
    margin-top: 40px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.5rem;

  > button:disabled:hover {
    background-color: ${colors.greyTextBlackBg};
  }

  > span {
    color: ${colors.greyTextWhiteBg};
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
  }
`

export const Success = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 1rem;
  color: ${colors.mainText};
  font-size: 18px;
  line-height: 27px;
  flex-direction: column;
  @media ${device.mobileMin} {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    font-size: 20px;
    line-height: 30px;
  }

  > img {
    width: fit-content;
    margin-left: -18px;
    margin-bottom: 16px;
    @media ${device.mobileMin} {
      margin-left: 0px;
      margin-bottom: 0px;
    }
  }
`

export const Notification = styled.div`
  margin-top: 24px;
  line-height: 21px;
  display: flex;
  align-items: flex-start;
  color: ${colors.messegesYellow1};
  column-gap: 0.5rem;
  text-align: left;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;

  > img {
    margin-top: 4px;
    width: fit-content;
  }
  @media ${device.mobileMin} {
    margin-top: 24px;
  }
`
